import styled, { css } from 'styled-components';
import { BaSeTheme } from '../../../theme';
import { SideMenuItemStyledProp } from './item';

interface SideMenuItemProps extends SideMenuItemStyledProp {
  active: boolean;
  backgroundColor: string;
  backgroundHoverColor: string;
}

export const SideMenuItemContainer = styled.li`
  width: 100%;
`;

export const SideMenuMainItem = styled.button<SideMenuItemProps>`
  background: none;
  width: 100%;
  box-sizing: border-box;
  border: none;
  display: flex;
  align-items: center;
  list-style: none;
  position: relative;
  padding: 16px;
  cursor: pointer;
  text-decoration: none;
  text-align: left;

  ${({
    hoverTextColor,
    selectedTextColor,
    bottomLineColor,
    active,
    backgroundColor,
    backgroundHoverColor,
  }) => css`
    background-color: ${backgroundColor};
    border-bottom: 1px solid ${bottomLineColor};

    &::before {
      content: '';
      position: absolute;
      left: 0;
      width: 0;
      background-color: ${selectedTextColor};
      top: 0;
      bottom: 0;
      will-change: width;
      transition: ${BaSeTheme.transitions.allPropertiesContinuousNormal};
    }

    ${active &&
    css`
      &::before {
        width: 4px;
      }
    `}

    &:hover, &:focus {
      color: ${hoverTextColor};
      background-color: ${backgroundHoverColor};
      outline: none;
    }
  `};

  img {
    margin-right: 8px;
  }

  > p,
  > small {
    min-width: 0;
    overflow-wrap: anywhere;
  }
`;

export const SideMenuChildItem = styled(SideMenuMainItem)<SideMenuItemProps>`
  font-weight: normal;
  font-size: 13px;
  padding: 8px 16px;
  border-bottom: none;

  &::before {
    display: none;
  }
`;
